import { useNavigate } from "react-router-dom";
import { cn } from "../../lib/utils";

export function SubTabs({ base, tab, items }) {
  const nav = useNavigate();
  return (
    <div className="flex items-center gap-1 border-b border-slate-200 mb-6 overflow-x-auto scrollbar-thin" data-testid="subtabs">
      {items.map((it) => (
        <button
          key={it.key}
          onClick={() => nav(`${base}/${it.key}`)}
          data-testid={`tab-${it.key}`}
          className={cn(
            "px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors",
            tab === it.key ? "border-primary text-primary" : "border-transparent text-slate-500 hover:text-slate-800"
          )}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}
